import React from 'react'

const ViewInfo = ({ label, value }) => (
  <div className='sm:py-4 sm:px-2 py-8 px-7'>
    <div className='relative z-0 mb-2 w-full group'>
      <strong>{label}</strong>
      <h6>{value}</h6>
    </div>
  </div>
)

export default ViewInfo
